import { render } from "./SystemTabAtividades.vue?vue&type=template&id=bc6eaea8&scoped=true&ts=true"
import script from "./SystemTabAtividades.vue?vue&type=script&lang=ts"
export * from "./SystemTabAtividades.vue?vue&type=script&lang=ts"

import "./SystemTabAtividades.vue?vue&type=style&index=0&id=bc6eaea8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc6eaea8"]])

export default __exports__